<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import { mapActions, mapState } from 'vuex'
import { createPopper } from '@popperjs/core'
import { getItemImage } from '@/helper'

export default {
  name: 'CartItem',
  props: {
    item: Object,
    /** Optional. When set, remove button calls this with the full item instead of removeItem(item.id). */
    onDeleteItem: { type: Function, default: undefined },
  },
  data() {
    return {
      productOptions: {},
    }
  },
  computed: {
    ...mapState('settings', [
      'settings',
      'pendingSettings',
    ]),
    ...mapState('eVouchers', ['cardStyles',]),
    ...mapState('summary', [ 'coinPacksOnly' ]),
    isVirtualCurrency() {
      return !this.pendingSettings &&
             this.settings.active_features &&
             this.settings.active_features.use_virtual_currency &&
             !this.coinPacksOnly
    },
    maxQuantity() {
      const list = []
      for (let i = 1; i <= this.productOptions.max_quantity; i++) {
        list.push(i)
      }
      return list
    },
    append_to_body() {
      return document.querySelector('.quick-cart-container') && document.querySelector('.quick-cart-container').classList.contains('quick-cart-container__mobile')
    },
  },
  methods: {
    getItemImage,
    ...mapActions('cart', [
      'removeItem',
      'updateCartItemOption',
    ]),
    getOptionId({ id }) {
      if (!this.item.product.options) return false
      let val
      this.item.product.options.forEach(opt => {
        if (opt.type_id === id) {
          return val = opt.value_id
        }
      })
      return val
    },
    getOptionValue({ id }) {
      if (!this.item.product.options) return false
      let val
      this.item.product.options.forEach(opt => {
        if (opt.type_id === id) {
          return val = opt.value_title
        }
      })
      return val
    },
    async updateCartItemVariant(variant) {
      if (this.item.product.variant_item.id !== variant) {
        await this.updateCartItemOption({ id: this.item.id, option: { variant } })
      }
    },
    async updateCartItemQuantity(amount) {
      await this.updateCartItemOption({ id: this.item.id, option: { amount } })
    },
    async updateCartItemOptions(value) {
      await this.updateCartItemOption({ id: this.item.id, option: { option: value } })
    },
    async removeCartItem() {
      if (this.onDeleteItem) {
        this.onDeleteItem(this.item)
      } else {
        await this.removeItem(this.item.id)
      }
    },
    getLocaleForUrl() {
      if (typeof window === 'undefined') return 'en-at'
      const match = window.location.pathname.match(/^\/([a-z]{2}[_-][a-z]{2})\//i)
      if (match) return match[1].toLowerCase().replace('_', '-')
      const fallback = this.$i18n.locale || window.config?.locale || 'en-at'
      return String(fallback).toLowerCase().replace(/_/g, '-')
    },
    slugify(text) {
      return String(text)
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '')
    },
    getProductUrl() {
      const product = this.item?.product
      if (!product) return null
      let url = product.url || product.get_url || product.url_path || this.item.product_url || this.item.url
      if (!url) {
        const locale = this.getLocaleForUrl()
        const id = product.article_number || product.id
        const slug = product.slug || this.slugify(product.name || product.title || '')
        if (slug && id) {
          url = `/${locale}/products/${slug}/${id}/`
        } else if (id) {
          url = `/${locale}/products/${id}/`
        }
      }
      if (!url) return null
      return url.startsWith('http') ? url : (window.location.origin + (url.startsWith('/') ? url : '/' + url))
    },
    goToProductDetail() {
      if (this.item.has_pdp) {
        const url = this.getProductUrl(this.item)
        if (url) window.location.href = url
      }
    },
    withPopper(dropdownList, component, { width }) {
      /**
       * We need to explicitly define the dropdown width since
       * it is usually inherited from the parent with CSS.
       */
      dropdownList.style.width = width

      /**
       * Here we position the dropdownList relative to the $refs.toggle Element.
       *
       * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
       * the dropdownList overlap by 1 pixel.
       *
       * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
       * wrapper so that we can set some styles for when the dropdown is placed
       * above.
       */
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: 'bottom',
        modifiers: [
          {
            name: 'offset', options: {
              offset: [
                0,
                -1,
              ],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle('drop-up', state.placement === 'top')
            },
          },
        ],
      })

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return () => popper.destroy()
    },
  },
}
</script>
